<!-- <div *ngIf="dataLoaded" class="bckGround">
  <h2 class="text-center topPadding">ENQUIRY FORM</h2>
  <h4 class="text-center mt-1 mb-2">{{ formSubTittle }}</h4>
</div> -->

<div *ngIf="dataLoaded" class="container mt-3">
  <form [formGroup]="webEnquiryForm" (ngSubmit)="onSubmit()">

    <div class="form-group mb-3">
      <label for="name" class="form-label dark-label required">Name</label>
      <input type="text" placeholder="Name" class="form-control" formControlName="name" />
    </div>

    <div class="form-group mb-3">
      <label for="email" class="form-label dark-label required">Email</label>
      <input type="text" placeholder="Email" class="form-control" formControlName="email" />
    </div>

    <div class="form-group mb-3">
      <label for="city" class="form-label dark-label required">City</label>
      <ng-select [items]="cityList" bindLabel="name" bindValue="_id" formControlName="city"
        placeholder="Select City" (change)="onSelectCity()"></ng-select>
    </div>

    <div *ngIf="isOthers" class="form-group mb-3">
      <label for="cityName" class="form-label dark-label required">City Name</label>
      <input type="text" formControlName="cityName" id="cityName" class="form-control"
        placeholder="Enter the city name" />
    </div>

    <div class="form-group mb-3">
      <label for="customerPhone" class="form-label dark-label required">Phone</label>
      <div class="row">
        <div class="col-3 pe-0">
          <ng-select [items]="countryCodeDropDownList" formControlName="countryCode" placeholder="Code"></ng-select>
        </div>
        <div class="col-9">
          <input type="text" formControlName="mobileNumber" id="mobileNumber" class="form-control"
            maxlength="12" placeholder="Enter mobile number" />
        </div>
      </div>
    </div>

    <div class="form-group mb-3">
      <label for="message" class="form-label dark-label">Message</label>
      <textarea placeholder="message" class="form-control" formControlName="message" rows="3"></textarea>
    </div>

    <div class="form-group">
      <div class="text-left mt-3">
        <button type="submit" [disabled]="webEnquiryForm.invalid" class="btn btn-primary me-2">
          Submit
        </button>
        <!-- <button type="button" (click)="formReset()" class="btn btn-secondary">
          Cancel
        </button> -->
      </div>
    </div>
  </form>
</div>

<ng-container *ngIf="!dataLoaded">
  <h3 class="text-center mt-5">
    Sorry, the form has expired. Please contact the admin.
  </h3>
</ng-container>